import getWeatherForecastOperation from 'owa-service/lib/operation/getWeatherForecastOperation';
import getWeatherForecastRequest from 'owa-service/lib/factory/getWeatherForecastRequest';
import GetWeatherForecastResponse from 'owa-service/lib/contract/GetWeatherForecastResponse';
import WeatherLocationId from 'owa-service/lib/contract/WeatherLocationId';
import TemperatureUnit from 'owa-service/lib/contract/TemperatureUnit';
import weatherLocationId from 'owa-service/lib/factory/weatherLocationId';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { makeGetRequest } from 'owa-ows-gateway';
import { isFeatureEnabled } from 'owa-feature-flags';
import { convertToGetWeatherForecastResponse } from '../utils/convertToGetWeatherForecastResponse';
import { getWeatherServiceUrl } from '../utils/getWeatherServiceUrl';

/**
 * Executes getWeatherForecastOperation
 * @param {TemperatureUnit} unit temperature units
 * @param {WeatherLocationId[]} weatherLocationIds list of weather location ids
 * @returns GetWeatherForecastResponse
 */
export default function getWeatherService(
    unit: TemperatureUnit,
    weatherLocationIds?: WeatherLocationId[]
): Promise<GetWeatherForecastResponse> {
    return isFeatureEnabled('cal-mf-shouldUseOWSPrimeWeatherApi')
        ? getNewWeatherService(unit, weatherLocationIds)
        : getOldWeatherService(unit, weatherLocationIds);
}

export function getOldWeatherService(
    unit: TemperatureUnit,
    weatherLocationIds?: WeatherLocationId[]
): Promise<GetWeatherForecastResponse> {
    return getWeatherForecastOperation({
        Header: getJsonRequestHeader(),
        Body: getWeatherForecastRequest({
            WeatherLocationIds: weatherLocationIds
                ? weatherLocationIds.map(id => {
                      return weatherLocationId(id);
                  })
                : [],
            TemperatureUnit: unit,
        }),
    }).then(response => {
        return response.Body;
    });
}

export function getNewWeatherService(
    unit: TemperatureUnit,
    weatherLocationIds?: WeatherLocationId[]
): Promise<GetWeatherForecastResponse> {
    return makeGetRequest(getWeatherServiceUrl(unit, weatherLocationIds)).then(response => {
        response.WeatherLocations.map(value => convertToGetWeatherForecastResponse(value));
        return response;
    });
}
